import OffShore from '@/components/Offshore';
import Layout from '@/components/Layout';
OffShore.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='offshore' >{page}</Layout>
    );
};

export default OffShore;


